import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import close from '../Asset/close.svg';
import { Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import Alert from './Alert';
import Table from './tables/myEquTable';
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import { environment } from './functions/environment';

function My_Equipment() {
  let userObj = getUserInfo();
  let [alert, setAlert] = useState({
    msg: "",
    status: false
  });
  let [sessOut, setSessOut] = useState(false);
  let [data, setData] = useState([]);
  let [threshold, setThreshould] = useState({
    targetUtilization: "",
    fuelLevel: "",
    batteryLevel: "",
    voltMeter: "",
    coolentTemprature: "",
    engineOilPressure: "",
    gForce: "",
    minCT: "",
    minEOP: ""
  });
  let [filter, setFilter] = useState({
    productCategoryID: "",
    productSubCategoryID: "",
    equipmentType: "",
    siteID: "",
  });
  let [showView, setShowView] = useState(false);
  let [showShiftModel, setShowShiftModel] = useState(false);
  let [showMapModel, setShowMapModel] = useState(false);
  let [filterShow, setFilterShow] = useState(false);
  let [cate, setCate] = useState([]);
  let [subCate, setSubCate] = useState([]);
  let [siteList, setSiteList] = useState([]);
  let [dropdownData, setDropDownData] = useState({
    asset_equipmentType: [
      { name: "" },
    ]
  });
  let [curGeo, setCurGeo] = useState({
    asset: "",
    gid: ""
  });
  let [geoList, setGeoList] = useState([]);

  useEffect(() => {
    let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
    let abortController = new AbortController();

    if (globObj && globObj != 'undefined') {
      setFilter({
        productCategoryID: globObj.productCategoryID,
        productSubCategoryID: globObj.productSubCategoryID,
        equipmentType: globObj.equipmentType,
        siteID: globObj.siteID,
      });
      getEquipment({
        productCategoryID: globObj.productCategoryID,
        productSubCategoryID: globObj.productSubCategoryID,
        equipmentType: globObj.equipmentType,
        siteID: globObj.siteID,
      });
      globObj.productCategoryID != "" ? getProductSubCategory(parseInt(globObj.productCategoryID)) : false;
    }
    else {
      getEquipment({});
    }
    getProductCategory();
    getSiteList();
    getDropDown();
    return () => {
      abortController.abort();
    }
  }, [])

  function closeMapModel() {
    setShowMapModel(false);
  }
  function setGeoModal(asset, geo, siteID) {
    setCurGeo({
      asset: asset,
      gid: geo
    });
    setShowMapModel(true);
    getGeoList(siteID.toString());
  }

  function resetFilter() {
    sessionStorage.removeItem('GloberFilter');
    setSubCate([]);
    setFilter({
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
    });
    getEquipment({});
  }
  function getProductCategory() {
    fetch(environment.baseUrl + "getProductCategory?", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setCate(resp.data.result.categories);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setCate([]);
        }
      })
    })
  }
  function getProductSubCategory(pid) {
    fetch(environment.baseUrl + "getProductSubCategory?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          "parentID": pid
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setSubCate(res.data.result.subCategories);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setSubCate([]);
        }
      })
    })
  }
  function getSiteList() {
    fetch(environment.baseUrl + "getSiteByUserAccount", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setSiteList(resp.data.result.siteList);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setSiteList([]);
        }
      })
    })
  }
  function getDropDown() {
    fetch(environment.baseUrl + "getDropDown", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "groupName": ["equipmentType"],
        "masterType": ["asset"]
      })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setDropDownData(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setDropDownData({
            asset_equipmentType: [
              { name: "" },
            ]
          })
        }
      })
    })
  }

  function getFilterData(e) {
    if (e.target.name === "productCategoryID" || e.target.name === "productSubCategoryID" || e.target.name === "siteID") {
      if (e.target.value == "") {
        setFilter({ ...filter, [e.target.name]: e.target.value });
      }
      else {
        setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
        if (e.target.name === "productCategoryID") {
          getProductSubCategory(parseInt(e.target.value));
        }
      }
    }
    else {
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
  }
  function getFilterFields() {
    getEquipment(filter);
  }

  function checkTreshould() {
    if (threshold.targetUtilization != "") {
      setShowView(true)
    }
    else {
      setAlert({
        msg: "This Asset not have Threshould Data",
        status: true
      })
    }
  }

  function getThreshold(accID, assetID) {
    fetch(environment.baseUrl + "getThresholdData", {
      method: "Post",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({ accountID: accID, assetID: assetID })
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          if (resp.data.result.length) {
            setThreshould({
              targetUtilization: resp.data.result[0].targetUtilization,
              fuelLevel: resp.data.result[0].fuelLevel,
              batteryLevel: resp.data.result[0].batteryLevel,
              voltMeter: resp.data.result[0].voltMeter,
              coolentTemprature: resp.data.result[0].maxCT,
              minCT: resp.data.result[0].minCT,
              engineOilPressure: resp.data.result[0].maxEOP,
              minEOP: resp.data.result[0].minEOP,
              gForce: resp.data.result[0].gForce
            });
            setShowView(true)
          }
          else {
            setAlert({
              msg: "Threshold data is not set for this equipment",
              status: true
            })
          }
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setThreshould({
            targetUtilization: "",
            fuelLevel: "",
            batteryLevel: "",
            voltMeter: "",
            coolentTemprature: "",
            engineOilPressure: "",
            gForce: "",
            minCT: "",
            minEOP: ""
          });
        }
      })
    })
  }
  function getEquipment(obj) {
    fetch(environment.baseUrl + "getEquipmentsByUser", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          productCategoryID: obj.productCategoryID,
          productSubCategoryID: obj.productSubCategoryID,
          equipmentType: obj.equipmentType,
          siteID: obj.siteID,
        }
      )
    }).then((result) => {
      result.json().then((res) => {
        setFilterShow(false);
        if (res.code == 200) {
          setData(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setData([]);
        }
      })
    })
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Asset ID ',
        accessor: 'assetID',
      },
      {
        Header: 'Account Name ',
        accessor: 'accountName',
      },
      {
        Header: 'Industry ',
        accessor: 'industry',
      },
      {
        Header: 'Service Branch ',
        accessor: 'serviceBranch',
      },
      {
        Header: 'Sales Branch ',
        accessor: 'salesBranch',
      },
      {
        Header: 'Service Dealer ',
        accessor: 'serviceDealer',
      },
      {
        Header: 'Product Category ',
        accessor: 'productCategory',
      },
      {
        Header: 'Product Sub-Category ',
        accessor: 'productSubCategory',
      },
      {
        Header: 'Geofence ',
        accessor: 'geofenceName',
      },
      {
        Header: 'Threshold ',
        accessor: 'threshold',
      },
      {
        Header: 'Shifts ',
        accessor: 'shifts',
      },
    ],
    []
  );

  let [selectEqu, setSelectEqu] = useState("");
  let [equShifts, setEquShifts] = useState([]);
  let [shiftStatus, setShiftStatus] = useState([]);

  function setShiftModel(assetID) {
    setSelectEqu(assetID);
    getShiftByEqu(assetID);
    setShowShiftModel(true);
  }

  function getShiftByEqu(id) {
    fetch(environment.baseUrl + "getShiftsByEquipment", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        assetID: id
      })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setEquShifts(res.data.result.shiftsDropdown);
        }
        else {
          setEquShifts([]);
        }
      })
    })
  }
  function getShiftStatus(e) {
    fetch(environment.baseUrl + "shiftStatus", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        assetID: selectEqu,
        shiftID: e.target.value
      })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setShiftStatus(res.data.result.shiftStatus);
        }
        else {
          setShiftStatus([]);
        }
      })
    })
  }
  function getGeoList(sid) {
    fetch(environment.baseUrl + "getGeofenceBySite", {
      method: "post",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        siteID: sid
      })
    }).then((result) => {

      result.json().then((res) => {
        if (res.code == 200) {
          setGeoList(res.data.result.geofenceList);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setGeoList([])
        }
      })

    })
  }
  function mapGeoWithEqu() {
    // console.log("cugeo:", curGeo)
    fetch(environment.baseUrl + "assetGeofenceMapping?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          "assetID": curGeo.asset,
          "geofenceID": curGeo.gid,
        })
    }).then((result) => {
      result.json().then(res => {
        setShowMapModel(false);
        if (res.code == 200) {
          setCurGeo({
            asset: "",
            gid: ""
          });
          getEquipment({});

        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setSubCate([]);
        }
        setAlert({
          msg: res.msg,
          status: true
        })
      })
    });
  }

  function closeShifModel() {
    setShowShiftModel(false);
    setSelectEqu("");
    setEquShifts([]);
    setShiftStatus([]);
  }

  function dateFormate(date) {
    let yy = date.slice(0, 4);
    let mm = date.slice(5, 7);
    let dd = date.slice(8, 10);

    return dd + "-" + mm + "-" + yy;
  }
  let show = true;
  function saveGlobelFilter() {
    sessionStorage.setItem("GloberFilter", JSON.stringify({
      equipmentID: filter.equipmentID ? filter.equipmentID : "",
      equipmentType: filter.equipmentType ? filter.equipmentType : "",
      siteID: filter.siteID ? filter.siteID : "",
      fromDate: filter.fromDate ? filter.fromDate : "",
      toDate: filter.toDate ? filter.toDate : "",
      month: filter.month ? filter.month : "",
      year: filter.year ? filter.year : "",
      productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
      productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
    }));
    getEquipment(filter);
  }
  return (
    <div className='main-container'>
      <Alert obj={alert} />
      <SessionFun show={sessOut}></SessionFun>
      <h4 className='main-heading'>My Equipment</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; My Equipment</p>
      <div className="row card-box-block mt-3">
        <div className="col-sm-12">
          <div className="row">
            <div className="col-sm-10 left-col">
              <h6 className='cardtitle'>Equipment List</h6>
            </div>
            <div className="col-sm-2  text-end">
              <FontAwesomeIcon icon={faBars} onClick={() => setFilterShow(true)} />
            </div>
          </div>
          <hr />
          <Table columns={columns} data={data} viewFun={getThreshold} shiftFun={setShiftModel} geoFun={setGeoModal} />
        </div>
      </div>

      <Modal show={filterShow} onHide={() => setFilterShow(false)} centered backdrop="static" size='lg'>
        <Modal.Header>
          <Modal.Title> Filter </Modal.Title>
          <button onClick={() => setFilterShow(false)} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className='logout-box'>
          <div className="row">
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Category</label>
                <Form.Select name='productCategoryID' className="textbox-back" value={filter.productCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    cate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Sub Category</label>
                <Form.Select name='productSubCategoryID' className="textbox-back" value={filter.productSubCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    subCate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Equipment Type</label>
                <Form.Select name='equipmentType' className="textbox-back" value={filter.equipmentType} onChange={getFilterData}>
                  <option value="">Select Equipment Type</option>
                  {
                    (dropdownData.asset_equipmentType).map((item, index) =>
                      <option key={index} value={item.name}>{item.name}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Site</label>
                <Form.Select name='siteID' className="textbox-back" value={filter.siteID} onChange={getFilterData}>
                  <option value="">Select Site</option>
                  {
                    siteList.map((item, index) =>
                      <option key={index} value={item.siteID}>{item.siteName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <button className="btn btn-outline-secondary lo-btn" onClick={resetFilter}>
              Reset
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn mx-3" onClick={getFilterFields}>
              Apply
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn" onClick={saveGlobelFilter}>
              Apply All
            </button>
          </div>
        </Modal.Body>
      </Modal>



      <Modal show={showView} onHide={() => setShowView(false)} centered backdrop="static" size='lg'>
        <Modal.Header>
          <Modal.Title> Threshold</Modal.Title>
          <button onClick={() => setShowView(false)} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          <div className="row">
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Target Utilisation</Form.Label>
                <Form.Control type="text" name='' value={threshold.targetUtilization} className="textbox-back" readOnly />
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Fuel Level</Form.Label>
                <Form.Control type="text" name='' value={threshold.fuelLevel} className="textbox-back" readOnly />
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Battery Level</Form.Label>
                <Form.Control type="text" name='' value={threshold.batteryLevel} className="textbox-back" readOnly />
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Volt Meter</Form.Label>
                <Form.Control type="text" name='' value={threshold.voltMeter} className="textbox-back" readOnly />
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Max Coolant Temperature</Form.Label>
                <Form.Control type="text" name='' value={threshold.coolentTemprature} className="textbox-back" readOnly />
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Min Coolant Temperature</Form.Label>
                <Form.Control type="text" name='' value={threshold.minCT ? threshold.minCT : "NA"} className="textbox-back" readOnly />
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>Max Engine Oil Pressure</Form.Label>
                <Form.Control type="text" name='' value={threshold.engineOilPressure} className="textbox-back" readOnly />
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label> Min Engine Oil Pressure</Form.Label>
                <Form.Control type="text" name='' value={threshold.minEOP ? threshold.minEOP : "NA"} className="textbox-back" readOnly />
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-3" >
                <Form.Label>G-Force</Form.Label>
                <Form.Control type="text" name='' value={threshold.gForce} className="textbox-back" readOnly />
              </Form.Group>
            </div>
          </div>

          <div className="row justify-content-end">
            <div className="col-sm-12">
              <button className="btn btn-outline-secondary lo-btn float-end" onClick={() => setShowView(false)}>
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>


      {/* shiftModel */}
      <Modal show={showShiftModel} onHide={closeShifModel} centered backdrop="static" size='lg'>
        <Modal.Header>
          <Modal.Title>Equipment vs Shift Timeline</Modal.Title>
          <button onClick={closeShifModel} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className='logout-box'>
          <p><b>{selectEqu}</b></p>
          <select className="form-select" aria-label="Default select example" onChange={getShiftStatus}>
            <option value="">Select</option>
            {
              equShifts.map((item, index) =>
                <option key={index} value={item.shiftID}>{item.shiftName}</option>
              )
            }
          </select>

          {
            shiftStatus.length ?
              <div className="table-responsive">
                <table className="table mt-3">
                  <thead className='table-secondary'>
                    <tr>
                      <th scope="col">Status</th>
                      <th scope="col">Start Date</th>
                      <th scope="col" style={{ whiteSpace: 'nowrap' }}>End Date</th>
                      <th scope="col">Operator Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      shiftStatus.map((item, index) =>
                        <tr key={index}>
                          <td style={{ whiteSpace: 'nowrap' }}>{item.isActive ? "Active" : "Inactive"}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>{item.allocationTime ? dateFormate(item.allocationTime) : "NA"}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>{item.relievingTime ? dateFormate(item.relievingTime) : "NA"}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>{item.operatorName ? item.operatorName : "NA"}</td>
                        </tr>
                      )
                    }

                  </tbody>
                </table>
              </div>
              :
              <p className='mt-3'><b>No data available</b></p>
          }
        </Modal.Body>
      </Modal>
      {/* shiftModel */}

      {/* geomap modal */}
      <Modal show={showMapModel} onHide={closeMapModel} centered backdrop="static" size='lg'>
        <Modal.Header>
          <Modal.Title>Map Geofence with Equipment</Modal.Title>
          <button onClick={closeMapModel} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className='logout-box'>
          <p><b>{curGeo.asset}</b></p>
          <Form.Group className="mb-2" >
            <label>Geofence</label>
            <Form.Select name='siteID' className="textbox-back" value={curGeo.gid} onChange={(e) => { setCurGeo({ ...curGeo, gid: e.target.value }) }}>
              <option value="">Select Geofence</option>
              {
                geoList.map((item, index) =>
                  <option key={index} value={item.geofenceID}>{item.geofenceName}</option>
                )
              }
            </Form.Select>
          </Form.Group>
          <div className="row m-0 justify-content-end mt-3">
            <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={mapGeoWithEqu}>
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* geomap modal */}

    </div>
  )
}

export default My_Equipment
